import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import HotGamesBg from '../../assets/image/leaderboardBg.png';
import Title from '../Title';


const OurPlatform = () => {
    const ourPlatform = useSelector((state) => state.auth.ourPlatform);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            // {
            //     breakpoint: 480,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //     },
            // },
        ],
    };

    return (
        <div style={{ backgroundImage: `url(${HotGamesBg})` }} className='h-[400px] bg-cover'>
            <div className='container mx-auto text-white my-10' >
                <Title title={"OUR"} continueTitle={"PLATFORM"} />
                <div className='mt-10'>
                    <Slider {...settings} className="custom-slick-slider">
                        {ourPlatform?.map((platform) => (
                            <div key={platform.id} className='px-2 mt-10 '>
                                <Link to={`/platform/description/${platform.id}`} >
                                    <img
                                        src={platform.game_image}
                                        alt={platform.game_name}
                                        className="w-[200px] h-[200px] object-cover border-2 border-[#FFDD15] rounded-lg"
                                    />
                                </Link>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default OurPlatform;
